var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-cell"},[(_vm.data.childTemplates > 0)?_c('router-link',{attrs:{"id":`gridCampaigns${_vm.data.id}`,"to":{name: 'TemplateDetailsCampaigns', query: {
      externalId: _vm.$route.query.externalId,
      clientId: _vm.$route.query.clientId,
      templateId: _vm.data.id,
      isSearchingTemplate: _vm.$route.query.isSearchingTemplate,
      isCreatingCampaign: _vm.$route.query.isCreatingCampaign,
      canCreateTemplate: _vm.$route.query.canCreateTemplate,
      userEmail: _vm.$route.query.userEmail} }}},[_c('span',{staticClass:"text-campaigs"},[_vm._v(_vm._s(_vm.data.childTemplates))])]):_c('span',{staticClass:"text-campaigs"},[_vm._v(_vm._s(_vm.data.childTemplates))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }